export default "__VITE_ASSET__DDRhvdw7__"